import { connect } from 'react-redux';
import ClientsSinglePageComponent from '../components/ClientsSinglePageComponent';
import { getClientsSingleDataIfNeeded } from '../actions/clientsActions';
import {
    playMediaFromSourceWithMeta, pauseMediaPlayer, playMediaPlayer,
} from '../../aovivoBar/actions/MediaPlayerActions';
import { showSpotModal } from '../../spot/actions/spotActions';

const mapStateToProps = (state) => ({
    clientsSingleData: state.clients.clientsSingleData,
    clientsSingleSlug: state.clients.clientsSingleSlug,
    isLoadingClientsData: state.clients.isLoadingClientsData,
    currentSources: state.aovivoBar.MediaPlayer.currentSources,
    playerStatus: state.aovivoBar.MediaPlayer.playerStatus,
});
const mapDispatchToProps = (dispatch) => ({
    getClientsSingleDataIfNeeded: (slug) => {
        dispatch(getClientsSingleDataIfNeeded(slug));
    },
    playMediaFromSourceWithMeta: (source, meta) => {
        dispatch(playMediaFromSourceWithMeta(source, meta));
    },
    pauseMediaPlayer: () => {
        dispatch(pauseMediaPlayer());
    },
    playMediaPlayer: () => {
        dispatch(playMediaPlayer());
    },
    showSpotModal: (spotSlug) => {
        dispatch(showSpotModal(spotSlug));
    },
});
const ClientsSinglePageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ClientsSinglePageComponent);

export default ClientsSinglePageContainer;
